/**
 * @module csp
 * this module will contain csp checks to aid in compatability of
 * older APK's in future.
 */


/**
 * this method checks DOM for CSP and in the instance of no dataURI support
 * it returns false!!!
 */
export function hasImageDataURISupport() {
  const csp = document.head.querySelector('meta[http-equiv="Content-Security-Policy"]');

  if (!csp) return true;

  const [imageSources] = csp.content.match(/img-src.*?(?:;|$)/) || [];

  if (!imageSources) return false;

  return imageSources.indexOf('data:') !== -1;
}

export default hasImageDataURISupport;



// WEBPACK FOOTER //
// ./src/lib/compat/csp.js